export default __webpack_public_path__ + "static/media/kanagi.e6e8e3fb.jpg";